import { useQuery } from "@tanstack/react-query";
import { getSearchResult } from "../../services/search";
import { LazyLoadImage } from "react-lazy-load-image-component";
import FilmCardItem from "../Common/FilmCardItem";
import Skeleton from "../Common/Skeleton";
import Pagination from "./Pagination";

const SearchResult = ({ currentTab, query, page, genresList }) => {
  const { data, error, isPreviousData } = useQuery(
    ["search-result", currentTab, query, page],
    () => getSearchResult(currentTab, query, page),
    {
      keepPreviousData: true,
    }
  );

  if (error) return <div>ERROR: ${error.message}</div>;

  const changePageHandler = (page) => {
    if (isPreviousData) return "";
    return `/search?query=${encodeURIComponent(query)}&page=${page}`;
  };

  return (
    <div className="md:mt-32 mt-7 mb-10">
      <div className="flex flex-col md:flex-row justify-start items-center text-white text-xl mb-6 gap-2">
        <p>Search results for "{query}"</p>
        <p>({data?.total_results} results found)</p>
      </div>
      {data && data.results.length === 0 && (
        <div className="flex flex-col items-center mb-12">
          <div className="flex justify-center ">
            <LazyLoadImage
              src="/empty.svg"
              alt="404Pic"
              className="w-[20vw] min-w-[250px] object-cover"
            />
          </div>
          <p className="mt-10 text-xl md:text-2xl text-white">
            No Results matching your search
          </p>
        </div>
      )}
      <ul className="flex flex-wrap items-start gap-x-[25px] gap-y-10 pl-2 pt-2 overflow-hidden">
        {data &&
          data?.results.length > 0 &&
          data.results.map((item) => (
            <li key={item.id}>
              <FilmCardItem item={item} genresList={genresList} />
            </li>
          ))}
        {!data &&
          [...new Array(15)].map((_, index) => (
            <li key={index}>
              <Skeleton className="!w-[200px] !h-[300px] shadow-sm rounded-md" />
            </li>
          ))}
      </ul>
      {data && data.total_pages > 1 && (
        <Pagination
          maxPage={data.total_pages}
          currentPage={data.page}
          onChangePage={changePageHandler}
        />
      )}
    </div>
  );
};

export default SearchResult;
